export default {
  isUrl(str = '') {
    return /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/.test(str)
  },

  // 将标准时间戳转换为中国时区的日期数据
  getCST(timestamp, format) {
    let offset = new Date().getTimezoneOffset() / 60,
      cstOffset = -8
    let cstDate = new Date(timestamp + ((offset - cstOffset) * 60 * 60 * 1000))

    return this.formatDate(cstDate, format)
  },

  formatDate(date = new Date(), format = 'yyyy-MM-dd hh:mm:ss') {
    if (!date) date = new Date()
    if (!(typeof date === 'object')) {
      let d = new Date(date)
      if (d.toString() === 'Invalid Date') {
        return console.error('日期格式不正确，请输入日期字符串、时间戳(毫秒)或Date对象\n', `Error Date Input: ${date}`)
      } else {
        date = d
      }
    }
    let map = {
      'M': date.getMonth() + 1, // 月份
      'd': date.getDate(), // 日
      'h': date.getHours(), // 小时
      'm': date.getMinutes(), // 分
      's': date.getSeconds(), // 秒
      'q': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    format = format.replace(/([yMdhmsqS])+/g, function(all, t) {
      let v = map[t];
      if (v !== undefined) {
        if (all.length > 1) {
          v = '0' + v
          v = v.substr(v.length - 2)
        }
        return v
      } else if (t === 'y') {
        let year = (date.getFullYear() + '').substr(4 - all.length)
        map.y = parseInt(year)
        return year
      }
      return all
    })
    return {
      date: date,
      dateString: format,
      dateMap: map
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/libs/utils.js